<template>
  <div class="taskPanel">
    <div class="header" :style="headerStyle"></div>
    <div class="taskItem" v-for="task in renderTasks" :key="task.id">
      <div class="content">
        <div class="taskBody">
          <span class="title">
            {{ task.taskName }}
            <span class="progress">{{ parseProgressText(task) }}</span>
          </span>
          <span class="text"
            >{{ $t('task_panel.earn')
            }}<span class="count"> {{ task.rewardNumber }} </span
            >{{ $tc('task_panel.chance', task.rewardNumber) }}
          </span>
        </div>
        <div
          :class="[
            'actionBtn',
            {
              alignBootom:
                typeof $uiTheme !== 'undefined' && $uiTheme === 'lalamove'
            }
          ]"
          :style="parseActionBtnStyle(task)"
          @click="throttleHandleTaskActionClick(task)"
        >
          {{ parseButtonName(task) }}
        </div>
      </div>
    </div>
    <div
      v-if="isShowCollapse"
      class="collapseSwitch"
      @click="handleCollapseSwitch"
    >
      {{ collapseSwitchText }}
      <div class="collapseIcon" :class="{ reverse: !isCollapsed }" />
    </div>
  </div>
</template>
<script>
import { gotoPage } from '@/components/templates/helper';
import {
  checkAppNotifyAuthStatus,
  callAppAction,
  isHllApp,
  throttle,
  isWxMiniProgram
} from '@/utils';
import { useCoupon } from '@/components/js/lalaPrize/lalaCoupon';

const TASK_STATUS_TEXT = {
  // 免费领取会员
  vip: {
    incomplete: '去领取',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 参与秒杀活动
  part_ms: {
    incomplete: '去秒杀',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 完成1单
  order_complete_n: {
    incomplete: '去完成',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 收藏司机
  favorite: {
    incomplete: '去收藏',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 抢红包雨
  enter_red_packet: {
    incomplete: '去完成',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 访问福利中心页
  visit_page: {
    incomplete: '去访问',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 完成1笔充值
  recharge_n: {
    incomplete: '去充值',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 充值n元
  recharge_amount: {
    incomplete: '去充值',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 每日签到
  sign_in: {
    incomplete: '签到',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 分享
  share: {
    incomplete: '去分享',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 邀请好友
  invite_friends: {
    incomplete: '去邀请',
    tomorrowAble: '明日再来',
    tomorrowUnable: '已完成'
  },
  // 打开消息通知
  open_message_push: {
    incomplete: '去打开',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 关注货主福利社
  attention_wx: {
    incomplete: '去关注',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  },
  // 完善个人信息
  perfecting_personal_information: {
    incomplete: '去完成',
    tomorrowAble: null,
    tomorrowUnable: '已完成'
  }
};

const TASK_STATUS = {
  INCOMPLETE: 0, // 未完成
  NEXT_TIME: 1, // 明日再来
  NOT_READY: 2, // 未开始
  COMPLETE: 3, // 已完成
  INVALID: 4 // 已失效
};

const COLLAPSE_BASE_LENGTH = 4; // 任务列表折叠长度
export default {
  data() {
    return {
      active: true,
      isCollapsed: true,
      TASK_STATUS_TEXT: this.taskStatusTextMap || TASK_STATUS_TEXT
    };
  },
  props: {
    titleImage: {
      type: String,
      required: true
    },
    buttonImage: {
      type: String,
      required: true
    },
    taskInfos: {
      type: Array,
      required: true
    },
    taskStatusTextMap: {
      type: Object,
      default: null
    }
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url("${this.titleImage}")`
      };
    },
    isShowCollapse() {
      return this.taskInfos.length > COLLAPSE_BASE_LENGTH;
    },
    collapseSwitchText() {
      return this.isCollapsed
        ? this.$t('task_panel.show_all')
        : this.$t('task_panel.hide');
    },
    renderTasks() {
      if (this.isShowCollapse && this.isCollapsed) {
        return this.taskInfos.slice(0, COLLAPSE_BASE_LENGTH);
      }
      return this.taskInfos;
    }
  },
  methods: {
    handleCollapseSwitch() {
      this.$emit('reportCollapseSwitch', {
        button_name: this.collapseSwitchText
      });
      this.isCollapsed = !this.isCollapsed;
    },
    parseActionBtnStyle(task) {
      return {
        background:
          task.status === 0
            ? `center / cover no-repeat url("${this.buttonImage}")`
            : 'linear-gradient(#e4e4e4 0%, #bbbbbb 100%)'
      };
    },
    parseProgressText(task) {
      if (task.progress) {
        return `（${task.progress.current}/${task.progress.total}）`;
      }
      return '';
    },
    parseButtonName(task) {
      const { status, taskCode: code } = task;
      if (!this.TASK_STATUS_TEXT[code]) {
        const msg = `unsupported：${code}`;
        this.$hll.toast(msg);
        throw new Error(msg);
      }
      if (status === TASK_STATUS.INCOMPLETE) {
        return this.TASK_STATUS_TEXT[code].incomplete;
      }
      if (status === TASK_STATUS.NEXT_TIME) {
        return (
          this.TASK_STATUS_TEXT[code].tomorrowAble ||
          this.TASK_STATUS_TEXT[code].tomorrowUnable
        );
      }
      if (status === TASK_STATUS.COMPLETE) {
        return this.TASK_STATUS_TEXT[code].tomorrowUnable;
      }
      if (status === TASK_STATUS.NOT_READY) {
        return this.$t('task_panel.not_ready');
      }
      if (status === TASK_STATUS.INVALID) {
        return this.$t('task_panel.expired');
      }
    },
    doTask(taskId, cb) {
      this.$emit('doTask', taskId, cb);
    },
    launchShare(options, cb) {
      this.$emit('launchShare', options, cb);
    },
    refreshTaskInfo() {
      this.$emit('refreshTaskInfo');
    },
    listenPageReturn() {
      window.addEventListener(
        'pageshow',
        event => {
          if (event.isTrusted || event.persisted) {
            this.refreshTaskInfo();
          }
        },
        { once: true }
      );
    },
    listenPageVisible(cb) {
      document.addEventListener(
        'visibilitychange',
        function onVisibilitychange() {
          if (document.visibilityState === 'visible') {
            document.removeEventListener(
              'visibilitychange',
              onVisibilitychange
            );
            cb && cb();
          }
        }
      );
    },
    throttleHandleTaskActionClick: throttle(async function(task) {
      if (task.status !== TASK_STATUS.INCOMPLETE) {
        return;
      }
      // 埋点
      const button_name = this.parseButtonName(task);
      this.$emit('reportClick', { task, button_name });
      switch (task.taskCode) {
        // 会员
        case 'vip':
          if (!isHllApp()) {
            this.$hll.toast('请在货拉拉APP中操作');
            return;
          }
          this.doTask(task.taskId, () => {
            this.listenPageReturn();
            gotoPage('vip');
          });
          break;
        // 参与秒杀活动
        case 'part_ms':
          if (!isHllApp() && !isWxMiniProgram()) {
            this.$hll.toast('请在货拉拉APP或微信小程序中操作');
            return;
          }
          gotoPage('part_ms');
          break;
        // 完成首单
        case 'complete_first_order':
          // 根据不同环境，点击跳转至货拉拉APP首页/微信小程序首页/货运m站
          useCoupon(
            task.supportBusinessLines && task.supportBusinessLines.length
              ? task.supportBusinessLines[0]
              : undefined
          );
          break;
        // 完成1单
        case 'order_complete_n':
          // 根据不同环境，点击跳转至货拉拉APP首页/微信小程序首页/货运m站
          useCoupon(
            task.supportBusinessLines && task.supportBusinessLines.length
              ? task.supportBusinessLines[0]
              : undefined
          );
          break;
        // 收藏司机 外H5/微信小程序/APP，点击收藏司机任务去完成按钮，吐司提示【请到货拉拉APP-收藏司机页面操作】
        case 'favorite':
          this.$hll.toast('请到货拉拉APP-收藏司机页面操作');
          break;
        // 访问福利中心页
        case 'visit_page':
          if (!isHllApp() && !isWxMiniProgram()) {
            this.$hll.toast('请在货拉拉APP或微信小程序中操作');
            return;
          }
          this.doTask(task.taskId, () => {
            this.listenPageReturn();
            gotoPage('visit_page');
          });
          break;
        // 完成n笔充值
        case 'recharge_n':
          gotoPage('recharge_n');
          break;
        // 充值n元
        case 'recharge_amount':
          gotoPage('recharge_amount');
          break;
        // 分享
        case 'share':
          this.launchShare({}, () => {
            this.doTask(task.taskId);
          });
          break;
        // 邀请n名好友
        case 'invite_friends':
          this.launchShare({ shareMode: 'invite' });
          break;
        // 签到
        case 'sign_in':
          this.doTask(task.taskId, () => {
            this.refreshTaskInfo();
            this.$hll.toast(this.$t('task_panel.signin_success'));
          });
          break;
        // 打开消息通知
        case 'open_message_push':
          await this.handleOpenNotify(task);
          break;
        // 关注货主福利社
        case 'attention_wx':
          this.doTask(task.taskId, () => {
            this.listenPageReturn();
            gotoPage('user_wx_pub_guide');
          });
          break;
        // 完善个人信息
        case 'perfecting_personal_information':
          if (!isHllApp()) {
            this.$hll.toast('请在货拉拉APP操作');
            return;
          }
          this.listenPageVisible(this.refreshTaskInfo.bind(this));
          gotoPage('personal_information');
          break;
      }
    }),
    async handleOpenNotify(task) {
      if (!isHllApp()) {
        this.$hll.toast(
          '请在手机权限中设置，完成后请至货拉拉APP该活动中，查看该任务的最新进度'
        );
        return;
      }
      let isOpend = false;
      try {
        isOpend = await checkAppNotifyAuthStatus();
      } catch (err) {
        this.$hll.toast({
          message:
            '请在手机权限中设置，完成后请至货拉拉APP该活动中，查看该任务的最新进度',
          timeout: 1500
        });
        setTimeout(() => {
          // 跳转 setting
          callAppAction('open_settings');
        }, 1500);
        return;
      }
      if (isOpend) {
        this.$hll.toast('任务已完成');
        this.doTask(task.taskId, () => {
          this.refreshTaskInfo();
        });
      } else {
        this.listenPageVisible(this.recheckOpenNotify.bind(this, task));
        // 跳转 setting
        callAppAction('open_settings');
      }
    },
    async recheckOpenNotify(task) {
      let isOpend = false;
      try {
        isOpend = await checkAppNotifyAuthStatus();
      } catch (err) {
        return;
      }
      if (!isOpend) {
        return;
      }
      this.doTask(task.taskId, () => {
        this.refreshTaskInfo();
      });
    }
  }
};
</script>

<style lang="less" scoped>
.taskPanel {
  margin: 0 auto;
  width: 100%;
  background: #ffffff;
  border-radius: 16px;
  padding-bottom: 32px;

  .header {
    margin: 0 auto;
    width: 460px;
    height: 100px;
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .taskItem {
    padding: 0 33px;

    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 26px 0;
      border-bottom: 1px solid #e8e8e8;
    }

    .taskBody {
      display: flex;
      flex-direction: column;
      justify-content: left;

      .title {
        font-size: 32px;
        color: #262626;

        .progress {
          color: #ff6600;
        }
      }

      .text {
        font-size: 28px;
        color: #8c8c8c;

        .count {
          color: #ff6600;
        }
      }
    }

    .actionBtn {
      min-width: 120px;
      padding: 0 20px;
      height: 52px;
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: normal;
      font-size: 28px;
      transform-origin: right;
      color: #ffffff;
      border-radius: 26px;

      &.alignBootom {
        align-self: flex-end;
      }
    }
  }

  .collapseSwitch {
    width: 100%;
    padding-top: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: normal;
    font-size: 28px;
    color: #8c8c8c;

    .collapseIcon {
      display: block;
      margin-left: 10px;
      width: 22px;
      height: 12px;
      background: center / cover no-repeat
        url('../assets/images/arrow-down.png');

      &.reverse {
        transform-origin: center;
        transform: rotate(180deg);
      }
    }
  }
}
</style>
